import image from 'shared/assets/images/integrationsSliders/googleCalendar/googleCalendar1.png'
import { LINK_GOOGLE_MEETING_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const google_calendar: IntegrationDetailsData = {
  subheadline: 'Connect Salesmsg with Google Calendar',
  overview:
    'Connect Salesmsg with Google Calendar so your AI Agent can book appointments directly from a text conversation. When a contact is ready to schedule, your AI Agent checks availability and confirms the meeting without any rep involvement.',
  keyBenefits: [
    'Book appointments automatically during AI Agent conversations',
    'Sync confirmed meetings to Google Calendar in real time',
    'Connect multiple Google accounts and choose which calendar receives new bookings',
    'Team members who connect their own calendar are added here automatically',
  ],
  images: [image],
  docs: LINK_GOOGLE_MEETING_GUIDE,
}
